<hpf-plateau-form
        *ngIf="plateau"
        [plateau]="plateau"
        (create)="onCreate($event)"
    ></hpf-plateau-form>
<div *ngIf="!plateau" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>